import { FC } from "react";

import { IconCheckmark } from "@/components/_icons/IconCheckmark";

import { FocusArea } from "../models/focus-area-model";

import { FocusAreaViewOptional } from "./focus-area-view-optional";

export interface FocusAreaSelectDropdownItemProps {
  focusArea?: FocusArea | null;
  selected?: boolean;
}

export const FocusAreaSelectDropdownItem: FC<FocusAreaSelectDropdownItemProps> = ({ focusArea, selected }) => {
  return (
    <div className="m-1 flex w-full cursor-pointer flex-row items-center gap-2 p-1 text-xs">
      <div className="min-w-0 grow">
        <FocusAreaViewOptional focusArea={focusArea} canWrapLabel />
      </div>
      <div className="mr-2 w-3">
        {selected && (
          <IconCheckmark className="mr-2 h-3 w-3 shrink-0 self-end justify-self-center text-foreground/60" />
        )}
      </div>
    </div>
  );
};
